import { Box, Heading, Text, UnorderedList, OrderedList, ListItem, Code, Link, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import React from 'react';

const MDXComponents = {
  h1: React.memo(({ children }) => (
    <Heading as="h1" size="2xl" mb={8} mt={8} color="gray.800">{children}</Heading>
  )),
  h2: React.memo(({ children }) => (
    <Heading as="h2" size="xl" mb={6} mt={8} color="gray.800">{children}</Heading>
  )),
  h3: React.memo(({ children }) => (
    <Heading as="h3" size="lg" mb={4} mt={6} color="gray.800">{children}</Heading>
  )),
  h4: React.memo(({ children }) => (
    <Heading as="h4" size="md" mb={4} mt={6} color="gray.800">{children}</Heading>
  )),
  p: React.memo(({ children }) => (
    <Text fontSize="lg" lineHeight="tall" mb={4} color="gray.700">{children}</Text>
  )),
  ul: React.memo(({ children }) => (
    <UnorderedList spacing={2} mb={4} pl={4}>{children}</UnorderedList>
  )),
  ol: React.memo(({ children }) => (
    <OrderedList spacing={2} mb={4} pl={4}>{children}</OrderedList>
  )),
  li: React.memo(({ children }) => (
    <ListItem fontSize="lg" color="gray.700">{children}</ListItem>
  )),
  code: React.memo(({ children }) => (
    <Code colorScheme="blue" px={2} py={1}>{children}</Code>
  )),
  pre: React.memo(({ children }) => (
    <Box
      as="pre"
      bg="gray.50"
      p={4}
      borderRadius="md"
      overflowX="auto"
      mb={4}
      whiteSpace="pre-wrap"
    >
      {children}
    </Box>
  )),
  a: React.memo(({ href, children }) => (
    <Link
      href={href}
      color="blue.500"
      textDecoration="none"
      _hover={{ textDecoration: 'underline' }}
      isExternal={href?.startsWith('http')}
    >
      {children}
    </Link>
  )),
  blockquote: React.memo(({ children }) => (
    <Box
      borderLeftWidth={4}
      borderLeftColor="blue.500"
      pl={4}
      py={2}
      my={4}
      color="gray.600"
      fontStyle="italic"
    >
      {children}
    </Box>
  )),
  table: React.memo(({ children }) => (
    <Box overflowX="auto" mb={4}>
      <Table variant="simple" size="md">
        {children}
      </Table>
    </Box>
  )),
  thead: Thead,
  tbody: Tbody,
  tr: Tr,
  th: React.memo(({ children }) => (
    <Th bg="gray.50" color="gray.700">{children}</Th>
  )),
  td: React.memo(({ children }) => (
    <Td borderColor="gray.200">{children}</Td>
  )),
  img: React.memo(({ src, alt, ...props }) => (
    <Box as="span" display="block" mb={4}>
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '8px'
        }}
        {...props}
      />
    </Box>
  ))
};

export default MDXComponents;